import React, {useState } from 'react'
import { ThemeProvider } from '@mui/material'
import {theme} from '../../../config/Dashboardtheme'
import CenteredTabs from '../../Views/Tabs'
import RemovalStats from '../molecule/RemovalStats'
import OptOuts , { BrokerOptOuts } from './OptOuts' 
import CircularProgress from '@mui/material/CircularProgress'
interface StatsProp {
  Brokers : any[]
  unmatchedBrokers : any[]
  OptOuts: BrokerOptOuts[]
  isDataFetched : boolean
}

const ExecutiveUsersDashboardGrid = (props: StatsProp) => {
  const [tabValue, setTabValue] = useState('Removal Stats')
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
  }
 
  return (
    <ThemeProvider theme={theme}>
      <CenteredTabs
        value={tabValue}
        handleChange={handleTabChange}
        isGrantDateValid={true}
        
      />
      {
        !props.isDataFetched ?
        <div style={{height:'400px', width:'100%', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
            <CircularProgress color = 'info'></CircularProgress>
        </div>
        : (tabValue === 'Removal Stats' ?
        <RemovalStats Brokers={props.Brokers} unmatchedBrokers={props.unmatchedBrokers} />
        : <OptOuts optouts={props.OptOuts} />
      )}
    </ThemeProvider>
  )
}

export default ExecutiveUsersDashboardGrid